module.exports = "/dist/images/52732ea39a0cf666754fa3540946ec49-404.jpg";